'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowRightTwoRectangles, iconArrowRightTwoRectanglesTag } from '@ni/nimble-components/dist/esm/icons/arrow-right-two-rectangles';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowRightTwoRectangles };
export { iconArrowRightTwoRectanglesTag };
export const NimbleIconArrowRightTwoRectangles = wrap(IconArrowRightTwoRectangles);